import { LegendBarChartTooltipProps } from '@shared/models/charts/legend-bar-chart.model.ts';

const LegendBarChartTooltip = ({
  active,
  payload,
  tooltipValueLabel,
  t
}: LegendBarChartTooltipProps) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const label = tooltipValueLabel && t ? t(tooltipValueLabel) : 'Count';

    return (
      <div
        className="bg-(--white) rounded-lg px-3 py-2"
        style={{ boxShadow: '0 4px 12px var(--black-alpha-150)' }}
      >
        <div className="text-base text-(--dark-2) mb-1">{data.name}</div>
        <div className="text-base" style={{ color: data.color }}>
          {label}: {data.value}
        </div>
      </div>
    );
  }
  return null;
};

export default LegendBarChartTooltip;
